angular.module('bribac.components.organizationDetails', [
  'bribac.translations'
])

  .component('organizationDetails', {
    templateUrl: 'organization-details-component.html',
    controller: 'OrganizationDetailsCtrl',
    bindings: {
      organization: '<'
    }
  })

  .controller('OrganizationDetailsCtrl', function() {
    var $ctrl = this

    $ctrl.$onChanges = function(changes) {
      if (changes.organization) {
        $ctrl.settings = Object.keys($ctrl.organization.settings)
          .filter(function(key) {
            return [
              'licenseType',
              'licenseInvoiceLimits',
            ].indexOf(key) === -1
          })
          .map(function(key) {
            return $ctrl.organization.settings[key]
          })
      }
    }
  })
